module.exports = __webpack_public_path__ + "img/delete_red.8dfb591f.png";